import Cookies from 'js-cookie';

const TOKEN_KEY = 'access_token';
const ADMIN_KEY = 'admin_data';

export interface AdminData {
  id_admin: string;
  email: string;
  role: string;
  is_active: boolean;
}

export const authUtils = {
  // Save token to cookie
  setToken: (token: string) => {
    Cookies.set(TOKEN_KEY, token, { 
      expires: 7, // 7 days
      sameSite: 'strict',
      secure: process.env.NODE_ENV === 'production' // Only use secure in production
    });
  },

  // Get token from cookie
  getToken: (): string | undefined => {
    return Cookies.get(TOKEN_KEY);
  },

  // Remove token from cookie
  removeToken: () => {
    Cookies.remove(TOKEN_KEY);
  },

  // Save admin data to cookie
  setAdminData: (adminData: AdminData) => {
    Cookies.set(ADMIN_KEY, JSON.stringify(adminData), {
      expires: 7,
      sameSite: 'strict',
      secure: process.env.NODE_ENV === 'production'
    });
  },

  // Get admin data from cookie
  getAdminData: (): AdminData | null => {
    const data = Cookies.get(ADMIN_KEY);
    if (!data) return null;
    try {
      return JSON.parse(data);
    } catch {
      return null;
    }
  },

  // Remove admin data from cookie
  removeAdminData: () => {
    Cookies.remove(ADMIN_KEY);
  },

  // Logout - clear all auth data
  logout: () => {
    authUtils.removeToken();
    authUtils.removeAdminData();
  },

  // Check if user is authenticated
  isAuthenticated: (): boolean => {
    return !!authUtils.getToken();
  },
};
